import React from "react";
import { useNavigate } from "react-router-dom";
import './Rules.scss';

const Rules = () => {
    const navigate = useNavigate();

    return (
        <div className="rules-page">
            {/* Header dans le même style que la page d'accueil */}
            <header className="home-header">
                <h1>Mémozyn Studio</h1>
                <h2>Règles du Jeu & Guide du Champion</h2>
                <div className="header-actions">
                    <button className="btn-header-action btn-mode-emploi" onClick={() => navigate('/')}>
                        ⬅ Retour à l'accueil
                    </button>
                </div>
            </header>

            {/* Séparation pleine largeur 10px double vert pomme identique à la page d'accueil */}
            <div className="header-full-separator" />

            {/* Contenu principal défilable avec scroll stylisé */}
            <main className="rules-main-content">
                <div className="rules-grid">
                    {/* Carte 1 : But du Jeu */}
                    <div className="rule-card card-but">
                        <div className="card-header-icon">
                            <span className="icon-badge">🎯</span>
                            <h3>1. But du Jeu</h3>
                        </div>
                        <p>
                            Affrontez vos amis dans une course passionnante au savoir et à la mémoire !
                            Le but ultime est de cumuler un <strong>maximum de points</strong> en répondant correctement aux questions et en réussissant les défis.
                        </p>
                        <div className="rule-highlight">
                            ⏱️ <strong>Durée de partie :</strong> La partie se joue en un nombre de tours défini à l'avance (5, 10, 15 ou 20 tours). Le joueur avec le plus haut score à la fin l'emporte !
                        </div>
                    </div>

                    {/* Carte 2 : Déroulement d'un tour */}
                    <div className="rule-card card-deroulement">
                        <div className="card-header-icon">
                            <span className="icon-badge">🎲</span>
                            <h3>2. Déroulement d'un Tour</h3>
                        </div>
                        <p>
                            Les joueurs jouent les uns après les autres selon leur ordre de tirage.
                        </p>
                        <ul className="rules-steps-list">
                            <li>
                                <strong>1. Lancer de dé :</strong> Le joueur dont c'est le tour clique sur le dé (depuis son écran ou sa manette mobile).
                            </li>
                            <li>
                                <strong>2. Déplacement du pion :</strong> Le pion avance automatiquement du nombre de cases indiqué par le dé sur le plateau.
                            </li>
                            <li>
                                <strong>3. Épreuve de case :</strong> Dès que le pion s'arrête, la question ou le défi correspondant à la case se déclenche pour tous les joueurs.
                            </li>
                        </ul>
                    </div>

                    {/* Carte 3 : Les différentes cases */}
                    <div className="rule-card card-cases">
                        <div className="card-header-icon">
                            <span className="icon-badge">🗺️</span>
                            <h3>3. Les Cases du Plateau</h3>
                        </div>
                        <div className="cases-detailed-list">
                            <div className="case-item case-quizz1">
                                <div className="case-badge-type">❓ QUIZZ I (30 pts)</div>
                                <p>Question à choix multiples accessible. Seul le joueur actif peut y répondre dans le temps imparti.</p>
                            </div>

                            <div className="case-item case-quizz2">
                                <div className="case-badge-type">❓ QUIZZ II (50 pts)</div>
                                <p>Question intermédiaire offrant plus de points. Répondez juste pour creuser l'écart au classement !</p>
                            </div>

                            <div className="case-item case-defi">
                                <div className="case-badge-type">⚔️ DÉFI BUZZER (100 pts)</div>
                                <p>Épreuve de rapidité intense ! Tous les joueurs ont l'œil sur l'écran : le premier qui buzze sur son buzzer prend la main pour répondre.</p>
                            </div>

                            <div className="case-item case-maison">
                                <div className="case-badge-type">🏠 MAISON (50 pts)</div>
                                <p>Atterrir sur sa propre maison octroie un bonus de 50 points. Atterrir chez un adversaire déclenche un duel direct !</p>
                            </div>

                            <div className="case-item case-bonus">
                                <div className="case-badge-type">🏆 CASE BONUS (100 pts)</div>
                                <p>Case centrale ultime : réussir cette question prestigieuse rapporte 100 points et permet un retour héroïque à votre maison !</p>
                            </div>
                        </div>
                    </div>

                    {/* Carte 4 : Fin de partie */}
                    <div className="rule-card card-victoire">
                        <div className="card-header-icon">
                            <span className="icon-badge">🥇</span>
                            <h3>4. Fin de Partie & Podium</h3>
                        </div>
                        <p>
                            Lorsque tous les tours sont écoulés, la cloche finale retentit ! 
                            Le grand écran affiche l'écran de victoire avec confettis, le nom du <strong>vainqueur</strong> et le classement complet de tous les joueurs.
                        </p>
                        <div className="rule-highlight green-highlight">
                            🚀 <strong>Rejouer :</strong> Le joueur hôte (créateur de la partie) peut relancer immédiatement une nouvelle manche avec les mêmes joueurs en 1 clic !
                        </div>
                    </div>
                </div>

                {/* Bouton de retour en bas de page */}
                <div className="rules-bottom-actions">
                    <button className="btn-action-premium btn-revenir" onClick={() => navigate('/')}>
                        Prêt à jouer ? Retour à l'accueil 🚀
                    </button>
                </div>

                {/* Footer */}
                <footer className="rules-footer">
                    &copy; 2026 Tous droits réservés à Memozyn Studio
                </footer>
            </main>
        </div>
    );
};

export default Rules;